import { $api } from '@service/RequestService';
import queryString from 'query-string';
import { useQuery } from 'react-query';
import { NumericArrayParam, StringParam, useQueryParams } from 'use-query-params';

import { PieChartModel, WidgetBodyModel } from '../models';

export function useChartWidget({ body, id }: { body: WidgetBodyModel; id: number }) {
  const [query] = useQueryParams({
    startDate: StringParam,
    finishDate: StringParam,
    responsibleByIds: NumericArrayParam
  });

  const parseQuery = queryString.stringify(query);

  const { data, ...arg } = useQuery<PieChartModel>(
    ['dashboard-v2-pie-chart', id, parseQuery],
    async () => {
      const { data } = await $api.post(`/v1/dashboard/widget/chart/v2${parseQuery ? `?${parseQuery}` : ''}`, body);

      return { ...data?.data };
    },
    {
      enabled: !!body?.dashboardId
    }
  );

  const largestValue = { ...(data?.filter || {}) }?.leadList?.sort((a, b) =>
    body?.amountType ? b?.amount! - a?.amount! : b?.count - a?.count
  )?.[0]?.count;

  return { ...data, largestValue, ...arg };
}
